import { useCallback, useEffect, useState } from "react"
import { useApi } from "../api"
import { AppHeader } from "../components/AppHeader"
import { MemberCounter } from "../components/MemberCounter"
import { ICargo } from "../interfaces"

export const InfoPage = () => {
  const api = useApi('SAI')
  const [isMounted, setMounted] = useState(false)
  const [number, setNumber] = useState(0)

  const fetchMemberCount = useCallback(() => {
    api.getMemberCount((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setNumber(cargo.info['count'])
      }
    })
  }, [api])

  useEffect(() => {
    if (!isMounted) {
      fetchMemberCount()
    }
    setMounted(true)
  }, [fetchMemberCount, isMounted])

  return (
    <>
      <AppHeader title='Information'></AppHeader>
      <div className='bg-sky-900 m-3 rounded-lg'>
        <MemberCounter memberNumber={number}></MemberCounter>
      </div>
      <div className="m-86"></div>
    </>
  )
}